import { render } from "./CharacterOne.vue?vue&type=template&id=e87903c6"
import script from "./CharacterOne.vue?vue&type=script&lang=js"
export * from "./CharacterOne.vue?vue&type=script&lang=js"

import "./CharacterOne.vue?vue&type=style&index=0&id=e87903c6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__